import React, { Component } from 'react';
import { Link } from 'redux-little-router';

import { routeMap } from 'router';

export default class UnknownParameters extends Component {
  render() {
    return (
      <div className="page_margin30">
        <p>Неверный ИНН/пароль</p>
        <Link href={routeMap.login}>Вернуться к форме авторизации</Link>
      </div>
    );
  }
}
